import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  inject
} from '@angular/core';
import { LegendParams } from '@jeppesen-foreflight/jmkw-types';
import { LegendControlBarComponent } from './legend-control-bar/legend-control-bar.component';
import { LegendFactoryService } from './legend-factory.service';

@Component({
  selector: 'jmkw-legend-wrapper',
  standalone: true,
  imports: [CommonModule, LegendControlBarComponent],
  templateUrl: './legend-wrapper.component.html',
  styleUrls: ['./legend-wrapper.component.scss'],
  providers: [LegendFactoryService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegendWrapperComponent {
  private readonly _legendFactory = inject(LegendFactoryService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);

  controlBarContent?: TemplateRef<any>;

  @Input() legendParams?: LegendParams;
  @Input() id?: string;

  constructor() {
    // Clean up when component is destroyed (navigation)
    this._destroyRef.onDestroy(() => {
      this._legendFactory.legendHost = null;
    });
  }

  @ViewChild('legendHost', { read: ViewContainerRef }) set legendHost(
    viewContainerRef: ViewContainerRef
  ) {
    this._legendFactory.legendHost = viewContainerRef;
    this._legendFactory.instantiateLegend(this.id, this.legendParams);
    this.controlBarContent =
      this._legendFactory.legendComponentRef?.instance.controlBarContent;
    this._cdr.detectChanges();
  }
}
